import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var IconBlock = styled.div.withConfig({
  displayName: "partials__IconBlock",
  componentId: "sc-15pnzfc-0"
})(["display:flex;align-items:center;"]);
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-15pnzfc-1"
})(["h6{font-weight:500;color:", ";}:hover{h6,", "{color:", ";}cursor:pointer;}h6:not(:last-child){padding-bottom:0;}display:flex;justify-content:space-between;padding:9px 8px;border-radius:", ";margin-bottom:8px;background:#fff;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.font;
}, IconBlock, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius;
});
export var Excerpt = styled.div.withConfig({
  displayName: "partials__Excerpt",
  componentId: "sc-15pnzfc-2"
})(["", " color:", ";"], getFont(-1), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.fontL;
});